import React from 'react';
import { LOGO_URL, footerQuickLinks, legalLinks, utilityLinks } from '../../data/site';
const linkClass = 'text-small-fluid font-medium text-brand-slate transition-colors duration-150 ease-out hover:text-brand-blue';
export function SiteFooter() {
  const resources = utilityLinks.filter(l => l.label !== 'Log In');
  return <footer className="bg-white" data-id="element-1" data-mp="xzdz4pwlf2d2">
      <div className="px-fluid grid gap-fluid py-[clamp(3.5rem,6vw,7rem)] md:grid-cols-12" data-id="element-2" data-mp="1lofeyy7r9fsd">
        <div className="md:col-span-6" data-id="element-3" data-mp="1lmm75fleopis">
          <a href="#top" className="inline-block" aria-label="David Moceri — back to top" data-id="element-4" data-mp="1qns1fhupskuf">
            <img src={LOGO_URL} alt="David Moceri" className="h-[clamp(2.5rem,1.8rem+1.6vw,4.25rem)] w-auto" data-id="element-5" data-mp="1coik2eurvkov" />
          </a>
          <p className="mt-5 text-small-fluid font-bold uppercase tracking-[0.18em] text-brand-navy" data-id="element-6" data-mp="1go13f66y3npl">
            Marketer · Motivator · Mentor
          </p>
        </div>
        <nav aria-label="Footer quick links" className="md:col-span-3" data-id="element-7" data-mp="5aoyerzg8z1u">
          <h2 className="text-small-fluid font-extrabold text-brand-navy" data-id="element-8" data-mp="1xvgz2m18k2xk">Quick Links</h2>
          <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3 md:grid-cols-1" data-id="element-9" data-mp="1xxbl63o8u138">
            {footerQuickLinks.map(link => <li key={link.label} data-id="element-10" data-mp="26wolo6ue3fbt">
                <a href={link.href} className={linkClass} data-id="element-11" data-mp="26xq97aslduaf">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <nav aria-label="Footer resources" className="md:col-span-3" data-id="element-12" data-mp="2gtkw4i3umbj0">
          <h2 className="text-small-fluid font-extrabold text-brand-navy" data-id="element-13" data-mp="2bv9n29ldo51u">Resources</h2>
          <ul className="mt-5 space-y-3" data-id="element-14" data-mp="2btfbvmzwrray">
            {resources.map(link => <li key={link.label} data-id="element-15" data-mp="2qjcr3dfv16o0">
                <a href={link.href} className={linkClass} data-id="element-16" data-mp="2llbcp5tdpviv">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>

      <div className="bg-brand-navy text-white" data-id="element-17" data-mp="2zihouhjlkvz4">
        <div className="px-fluid flex flex-col gap-4 py-6 text-[clamp(0.75rem,0.7rem+0.15vw,0.95rem)] lg:flex-row lg:items-center lg:justify-between" data-id="element-18" data-mp="2umsnq9rxj70p">
          <p className="text-white/85" data-id="element-19" data-mp="1x7fts6dhsxz7">© 2026 David Moceri, an Ad ROI, LLC Company. All Rights Reserved.</p>
          <nav aria-label="Legal" data-id="element-20" data-mp="2191bq64vw2g9">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-21" data-mp="217yme2n7m82g">
              {legalLinks.map(link => <li key={link.label} data-id="element-22" data-mp="260jgl5a12n6i">
                  <a href={link.href} className="text-white/90 underline-offset-4 hover:text-white hover:underline" data-id="element-23" data-mp="261ksfbyvbdpa">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>
      </div>
    </footer>;
}